import '../css/Footer.css'

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faInstagram, faWhatsapp, faTiktok } from "@fortawesome/free-brands-svg-icons"

function Footer() {
  return (
    <footer>
      <div className="footerContainer">
        <div className="footerRow">
          <div className="footerCol">
            <h2>Institucional</h2>
            <ul className="footerLinks">
              <li><a href="/" className="footerLink">Início</a></li>
              <li><a href="/matricule-se" className="footerLink">Matricule-se</a></li>
              <li><a href="/contato" className="footerLink">Contato</a></li>
              <li><a href="https://cpa.escolarmanageronline.com.br/colegiolider" target='_blank' rel='noreferrer' className="footerLink">Aluno Online</a></li>
              <li><a href="https://professor.escolarmanageronline.com.br/colegiolider/Login" target='_blank' rel='noreferrer' className="footerLink">Portal do Professor</a></li>
            </ul>
          </div>
          <div className="footerCol">
            <h2>Ensino</h2>
            <ul className="footerLinks">
              <li><a href="/ensino-fundamental-1" className="footerLink">Ensino Fundamental 1</a></li>
              <li><a href="/ensino-fundamental-2" className="footerLink">Ensino Fundamental 2</a></li>
              <li><a href="/ensino-medio" className="footerLink">Ensino Médio</a></li>
            </ul>
            <div className="socialIcons">
              <a href="https://www.instagram.com/colegiolidergo/" target='_blank' rel='noreferrer' aria-label="Instagram do Colégio Líder (abre em nova aba)">
                <FontAwesomeIcon icon={faInstagram} style={{ color: "#E1306C", fontSize: 35 }} />
              </a>
              <a href="https://wa.me/5562998271550" target='_blank' rel='noreferrer' aria-label="WhatsApp do Colégio Líder (abre em nova aba)">
                <FontAwesomeIcon icon={faWhatsapp} style={{ color: "#25D366", fontSize: 35, }} />
              </a>
              <a href="https://www.tiktok.com/@colegiolidergo" target='_blank' rel='noreferrer' aria-label="TikTok do Colégio Líder (abre em nova aba)">
                <FontAwesomeIcon icon={faTiktok} style={{ color: "#000000", fontSize: 27 }} />
              </a>
            </div>
          </div>
        </div>
        <div className="footerRow" id="contact">
          <div style={{alignItems: 'flex-end', textAlign: 'right'}}>
            <p className="footerContact">
              <b>Endereço: <br></br></b>
                Rua José da Cunha, Quadra 126, Lotes 19/24<br></br>St. dos Afonsos, Aparecida de Goiânia - GO, 74915-340
            </p>
            <p className="footerContact">
              <b>Telefone: <br></br></b>
                <a href='tel:+6235480070'>(62) 3548-0070</a>
            </p>
            <p className="footerContact">
              <b>WhatsApp: <br></br></b>
                <a href="https://api.whatsapp.com/send?phone=5562998271550&text=Bom%20dia!" target="_blank" rel="noopener noreferrer">(62) 99827-1550</a>
            </p>
            <p className="footerContact">
              <b>Email: <br></br></b>
                <a href='mailto:recep@colegiolidergo.com.br'>recep@colegiolidergo.com.br</a>
              </p>
          </div>
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-end', justifyContent: 'center'}}>
            <a style={{display: 'flex', width: 'fit-content', height: 'fit-content', marginTop: -15 + 'px', alignItems: 'right', justifyContent: 'right'}} href='/'>
              <img src={'assets/images/logo/colegio-lider.png'} style={{margin: 0, padding: 0}} alt="Líder" id='logo'/>
            </a>
          </div>
        </div>
      </div>
      <p className="copyright">Copyright © Colégio Líder - {new Date().getFullYear()} Todos os direitos reservados.</p>
    </footer>
  );
}

export default Footer;